import { createAction } from "@reduxjs/toolkit";

import { SessionInfo } from ".././common/Info";

// const increment = createAction<number | undefined>('counter/increment')

const setSession = createAction<SessionInfo>("session/setSession");

export { setSession };
